import { getTimeSuggestionsStore } from '../selectors/getTimeSuggestionsStore';
import { mutatorAction, mutator } from 'satcheljs';
import type { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { showSearchCriteriaDialog } from '../actions/internalActions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import TimingType from '../store/schema/TimeSuggestionsTimingTypes';
import { getValidDuration } from '../utils/getValidDuration';

export const showSearchCriteriaDialogMutator = mutator(showSearchCriteriaDialog, actionMessage => {
    const store = getTimeSuggestionsStore(actionMessage.viewStateId);
    store.showSearchCriteriaDialog = true;
    store.durationSearchCriteria = getValidDuration(
        actionMessage.event.Start,
        actionMessage.event.End
    );
});

export const initializeSearchCriteria = mutatorAction(
    'initializeSearchCriteria',
    (event: CalendarEvent, viewStateId: string | null) => {
        const store = getTimeSuggestionsStore(viewStateId);
        store.timingSearchCriteria = TimingType.NextAvailable;
        store.durationSearchCriteria = getValidDuration(event.Start, event.End);
    }
);

export const hideSearchCriteriaDialog = mutatorAction(
    'hideSearchCriteriaDialog',
    (viewStateId: string | null) => {
        const store = getTimeSuggestionsStore(viewStateId);
        store.showSearchCriteriaDialog = false;
    }
);

export const onDurationChanged = mutatorAction(
    'onDurationChanged',
    (option: IDropdownOption, viewStateId: string | null) => {
        const store = getTimeSuggestionsStore(viewStateId);
        store.durationSearchCriteria = Number(option.key);
    }
);

export const onTimingChanged = mutatorAction(
    'onTimingChanged',
    (option: IDropdownOption, viewStateId: string | null) => {
        const store = getTimeSuggestionsStore(viewStateId);
        store.timingSearchCriteria = option.key as TimingType;
    }
);

export const updateSearchCriteriaTiming = mutatorAction(
    'updateSearchCriteriaTiming',
    (timingType: TimingType, viewStateId: string | null) => {
        const store = getTimeSuggestionsStore(viewStateId);
        store.timingSearchCriteria = timingType;
    }
);
